export const PTMessage = {
  root: ({ props }: any) => ({
    className: 'ax-inline-message ax-inline-message--' + props.severity,
  }),
  icon: {
    className: 'ax-inline-message__icon shrink-0',
  },
  text: {
    className: 'ax-inline-message__text',
  },
};
